import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Track your activity across the network with a unified score. The more you participate, the higher your score grows! ")
const _hoisted_2 = { class: "text-2xl font-bold text-white bg-purple-700 py-1 px-4 rounded-full" }
const _hoisted_3 = { class: "truncate" }
const _hoisted_4 = { class: "text-green-500 font-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Account score is calculated by a number of factors, primarily dependent on the types and quantity of transactions sent and received. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Transaction Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Points")
  ])
], -1)
const _hoisted_7 = { class: "text-green-600 font-bold" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Total score: ")
const _hoisted_9 = { class: "whitespace-nowrap" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Transaction Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Sender"),
    /*#__PURE__*/_createElementVNode("th", null, "Receiver"),
    /*#__PURE__*/_createElementVNode("th", null, "Points"),
    /*#__PURE__*/_createElementVNode("th", null, "Date")
  ])
], -1)
const _hoisted_11 = {
  class: "truncate",
  style: {"max-width":"200px"}
}
const _hoisted_12 = {
  class: "truncate",
  style: {"max-width":"200px"}
}
const _hoisted_13 = { class: "text-green-600 font-bold" }
const _hoisted_14 = { class: "italic" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["datetime"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderListButtonTemplate = _resolveComponent("HeaderListButtonTemplate")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_DashboardCard = _resolveComponent("DashboardCard")!

  return (_openBlock(), _createBlock(_component_DashboardCard, {
    title: "Score",
    embed: "embed:score"
  }, {
    help: _withCtx(() => [
      _hoisted_1
    ]),
    action: _withCtx(() => [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.helpModalOpen = true)),
        class: "px-2 py-1 bg-white dark:bg-gray-800 rounded-md text-sm font-medium text-gray-500 dark:text-gray-300 shadow whitespace-nowrap hover:text-gray-800 dark:hover:text-gray-400"
      }, " How to score? ")
    ]),
    default: _withCtx(() => [
      _createVNode(_component_HeaderListButtonTemplate, {
        listTitle: "Recent earnings",
        buttonText: "View scores",
        empty: _ctx.scoringActions.length === 0,
        onExpand: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewModalOpen = true))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$filters.number.standard(_ctx.score)), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scoringActions.slice(0, 4), (action, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$filters.humanize.actionKind(action.actionKind)), 1),
              _createElementVNode("div", _hoisted_4, " +" + _toDisplayString(_ctx.$filters.number.compact(action.score)), 1)
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["empty"]),
      _createVNode(_component_Modal, {
        open: _ctx.helpModalOpen,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.helpModalOpen = false)),
        title: "How to earn points",
        prose: ""
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createElementVNode("table", null, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scoreTable, (entry) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: entry.name
                }, [
                  _createElementVNode("td", null, _toDisplayString(entry.name), 1),
                  _createElementVNode("td", _hoisted_7, "+" + _toDisplayString(entry.points), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"]),
      _createVNode(_component_Modal, {
        open: _ctx.viewModalOpen,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.viewModalOpen = false)),
        title: "Scores",
        prose: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, [
            _hoisted_8,
            _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.number.standard(_ctx.score)), 1)
          ]),
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scoringActions, (entry, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$filters.humanize.actionKind(entry.actionKind)), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(entry.action.signer_account_id), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(entry.action.receiver_account_id), 1),
                  _createElementVNode("td", _hoisted_13, "+" + _toDisplayString(entry.score), 1),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("a", {
                      href: 
                    _ctx.networks[_ctx.network].explorer +
                    '/transactions/' +
                    entry.action.transaction_hash
                  ,
                      target: "_blank",
                      rel: "noreferrer"
                    }, [
                      _createElementVNode("time", {
                        datetime: 
                      _ctx.$filters.nearTimestampToISO(entry.action.block_timestamp)
                    
                      }, _toDisplayString(_ctx.$filters.nearTimestampToLocaleString(
                        entry.action.block_timestamp,
                        _ctx.DateTime.DATETIME_MED,
                      )), 9, _hoisted_16)
                    ], 8, _hoisted_15)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }))
}